import { render, staticRenderFns } from "./c-mobile-whistleblower-popup.vue?vue&type=template&id=22f65602&scoped=true"
import script from "./c-mobile-whistleblower-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./c-mobile-whistleblower-popup.vue?vue&type=script&setup=true&lang=js"
import style0 from "./c-mobile-whistleblower-popup.vue?vue&type=style&index=0&id=22f65602&prod&lang=css"
import style1 from "./c-mobile-whistleblower-popup.vue?vue&type=style&index=1&id=22f65602&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f65602",
  null
  
)

export default component.exports